module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0034.jpg?v=00f5b9dc";